import React, { useContext, Fragment } from "react";
import { ProductContext } from "../../context";
import { CssLeft, CssOrderNum, CssActions} from "./UserAccount";
import { orders, ordersgame, namedOrders } from './orders';
import styled, { css } from "styled-components";
import { CssImage, CSSproductDesc, CssPrice, CssPaper, CssPopSection, CssFormGroup, Button, CssContentBlock } from "./../uikit-b2c/uikit-b2c";
import { Paper } from '../uikit-b2c/uikit-b2c';
import { CssCols } from './UserAccountRefunds';
import { Order, OrderRight } from './OrderLine';


export const CartItems = ({
  orderData = 'many',
  collapsed,
  limit,
  filter
}) => {

  orders['orders'].filter((oneOrder) => oneOrder['purchase']['virtual_item'] || oneOrder['purchase']['virtual_currency'])
  console.log('orders[orders] = ', orders['orders']);

  // orders['orders'].length = limit ? limit : orders['orders'].length;

  // let oneOrder = [orders['orders'][1]]
  let oneOrder = [namedOrders[orderData]]

  return (<Fragment>

  {(filter === 'virtual_item' ||
    filter === 'virtual_currency' ||
    filter === 'subscription'
  )

  && <div style={{ width: '100%' }}>

    {oneOrder.map((oneOrder, ind) => {
      if (
        // true
        // (typeof limit === 'undefined' || (Boolean(limit) && ind < limit)) &&
        (oneOrder && oneOrder['purchase']['virtual_item'] || oneOrder['purchase']['virtual_currency'])
        ) {
        return (<CartOneItem
          collapsed={collapsed}
          key={`order_${oneOrder['operation_id']}`}
          purchase={oneOrder['purchase']}
          filter={filter}
           />);
      }
      else {
        return null;
      }
    })}


  </div>}

  {filter === 'gamekey' && <div style={{ width: '100%' }}>

    {ordersgame.map((oneOrder, ind) => {

        return (<CartOneGame

          key={`order_game_${ind}`}
          {...oneOrder}
        />);
      }
    )}
  </div>}

  </Fragment>
  );
};







export const CartOneGame = (props) => {

  const {
    image_url = 'https://cdn3.xsolla.com/img/misc/images/8f71d99c7c5e68dbaf2bd3930186a2ca.png',
    localized_name = 'Blasphemous',
    drms = [
      'steam', 'switch', 'gog', 'ps4', 'xbox'
    ],
    defaultPrice = '$19.99',

  } = {...props}

  return (<CssFormGroup indentation='md'>

      <OrderRight>

          <Order
            collapsed={false}
            image_url = {image_url}
            name = {localized_name}
            description = ''
            price = {defaultPrice}
            quantity = {1}
            type = 'game'
          />
      </OrderRight>

    </CssFormGroup>
  )
}


export const CartOneItem = ({
  collapsed,
  filter = false,
  purchase,
  operation_id = 95806539,
  date = "2017-07-10 23:10",

  type = 'order',
}) => {
  let virtual_item = purchase['virtual_item'];
  let virtual_currency = purchase['virtual_currency'];
  let subscription = purchase['subscription'];
  const valueFromContext = useContext(ProductContext);
  if (
    true
    // (!filter && (virtual_item || virtual_currency)) ||
    // (filter === 'subscription' && subscription)
    ) {
    return (<CssFormGroup indentation='md'>
      <OrderRight>
      {(virtual_item && filter === 'virtual_item') && virtual_item.map((oneOrd, index) => {
        return (<Order
          collapsed = {collapsed}
          type="virtual_item"
          key={`oneorder_${index}`}
          image_url={oneOrd['image']}
          sku={oneOrd['sku']}
          name={oneOrd['name']}
          description={oneOrd['description']}
          quantity={oneOrd['quantity']} />);
      })}
      {(virtual_currency && filter === 'virtual_currency') && virtual_currency.map((oneOrd, index) => {
        return (<Order
          collapsed = {collapsed}
          key={`oneorder_${index}`}
          type="virtual_currency"
          name={oneOrd['name']} />);
      })}
      {(subscription && filter === 'subscription') && subscription.map((oneOrd, index) => {
        return (<Order
          collapsed = {collapsed}
          key={`oneorder_${index}`} type="subscription" icon='https://res.cloudinary.com/maiik/image/upload/v1567205189/Xsolla_Store_icons/ic_coins_subs.svg'
            name="Monthly Subscription"
            description="Starting Aug 17 2020"
          ></Order>);
      })}
      </OrderRight>

    </CssFormGroup>);
  }
  else {
    return null;
  }
};


const CSSelement = styled.div`
  display: grid;
  grid-auto-columns: minmax(100px, auto);
  grid-column-gap: 16px;
  grid-row-gap: 16px;
`